(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }
  customElements.define('cart-note', CartNote);
	
  let couponCodeField = document.getElementById('coupon-code'),
	  couponCodeGet = localStorage.getItem("coupon");
  couponCodeField.value = couponCodeGet;



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    

  // const handleIntersection = (entries, observer) => {
  //   if (!entries[0].isIntersecting) return;

  //   observer.unobserve(productRecommendationsSection);

  //   const url = productRecommendationsSection.dataset.url;

  //   fetch(url)
  //     .then(response => response.text())
  //     .then(text => {
  //       const html = document.createElement('div');
  //       html.innerHTML = text;
  //       const recommendations = html.querySelector('.product-recommendations');

  //       if (recommendations && recommendations.innerHTML.trim().length) {
  //         productRecommendationsSection.innerHTML = recommendations.innerHTML;
  //       }
  //       extraLargeDesktopShow = parseInt(document.querySelector('.product-recommendations-data').dataset.showExtraLarge);
  //       largeDesktopShow = parseInt(document.querySelector('.product-recommendations-data').dataset.showLarge);
  //       tabletShow = parseInt(document.querySelector('.product-recommendations-data').dataset.showTablet);
  //       mobileShow = parseInt(document.querySelector('.product-recommendations-data').dataset.showMobile);
  //       var swiper =  new Swiper(".slider-recommendation", {
  //         slidesPerView: 1,
  //         loop: false, 
  //         spaceBetween: 0,
  //         navigation: {
  //             clickable:true,
  //             nextEl: ".swiper-button-next",
  //             prevEl: ".swiper-button-prev",   
  //         },
  //         pagination: {
  //             el: ".swiper-pagination-slider",
  //             clickable:true,
  //           },
  //         breakpoints: {
  //           0: {
  //             slidesPerView: 1,
  //           },
  //           600: {
  //             slidesPerView: mobileShow,
  //           },
  //           768: {
  //             slidesPerView: tabletShow,
  //           },
  //           1024: {
  //             slidesPerView: largeDesktopShow,
  //           },
  //           1280: {
  //             slidesPerView: extraLargeDesktopShow,
  //           },
  //         },
  //       });

  //     })
  //     .catch(e => {
  //       console.error(e);
  //     });
  // };

  // const productRecommendationsSection = document.querySelector('.product-recommendations');
  // const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

//   // observer.observe(productRecommendationsSection);
//   var loadProductRecommendationsIntoSection = function() {
//   // Look for an element with class 'product-recommendations'
//   var productRecommendationsSection = document.querySelector(".product-recommendations");
//   if (productRecommendationsSection === null) { return; }
//   // Read product id from data attribute
//   var productId = productRecommendationsSection.dataset.productId;
//   // Read limit from data attribute
//   var limit = productRecommendationsSection.dataset.limit;
//   // Build request URL
//   var requestUrl = "/recommendations/products?section_id=product-recommendations&limit="+limit+"&product_id="+productId;
//   // Create request and submit it using Ajax
//   var request = new XMLHttpRequest();
//   request.open("GET", requestUrl);
//   request.onload = function() {
//     if (request.status >= 200 && request.status < 300) {
//       var container = document.createElement("div");
//       container.innerHTML = request.response;
//       productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;
//     }
//   };
//   request.send();
// };
// // If your section has theme settings, the theme editor
// // reloads the section as you edit those settings. When that happens, the
// // recommendations need to be fetched again.
// // See https://help.shopify.com/en/themes/development/sections/integration-with-theme-editor
// document.addEventListener("shopify:section:load", function(event) {
//   if (event.detail.sectionId === "product-recommendations") {
//     loadProductRecommendationsIntoSection();
//   }
// });
// // Fetching the recommendations on page load
// loadProductRecommendationsIntoSection();




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slider-swiper"] && !Shopify.designMode) return;
  try {
    
const slider = document.querySelector('.js-slider')

if (slider) {
   const loop = slider.getAttribute('data-autorotate') === 'true'
   const delay = slider.getAttribute('data-speed')

   const mySwiper = new Swiper('.js-slider', {
      loop,
      autoplay: {
         delay,
      },
      pagination: {
         el: '.swiper-pagination',
         clickable: true
      },
      navigation: {
         nextEl: '.swiper-button-next',
         prevEl: '.swiper-button-prev',
      },
   })
}

  } catch(e) { console.error(e); }
})();
})();
